(ns ycweb.app.website.demo.demo
  (:require
   [ycweb.components.flow :as flow]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.forms :as forms]
   [ycweb.components.common :as cmn]
   [ycweb.util.comms :as comms]
   [ycweb.components.grid :as grid]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.components.headings :as headings]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.app.website.header.header]
   [ajax.core :as ajax]
   [ycweb.app.website.footer.footer]

    ;;todo - add all new sections here
   [ycweb.app.website.demo.test]
   [ycweb.app.website.demo.keepaside :as keepaside]
   [ycweb.app.website.demo.authmodals :as authmodals]))


(rum/defc demo-list-page < rum/reactive [app-atom]
  [:div
   {:class (u/bem :yc-page-content [:default])}
   [:div.yc-section
    [:h1 {:class (u/bem :yc-heading [:large])} "Auth flow design demo"]
    [:ul.yc-list
     [:li
      [:b
       [:a.text-link
        {:href "#"
         :on-click
         #(grid/open-modal app-atom :web.demo/login-start
            {:config
             {:size :small
              :blur-bg? true}})}
        "Open login start modal"]]
      [:ul
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/login-with-email
             {:config
              {:size :small
               :blur-bg? true}})}
         "Open email login modal"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/login-accountnotfound
             {:config
              {:size :small
               :blur-bg? true
               :error? true}})}
         "Open email doesn't exist modal (account not found)"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/login-combonotfound
             {:config
              {:size :small
               :blur-bg? true
               :error? true}})}
         "Open email / password mismatch modal (login error)"]]]]
     [:li
      [:b
       [:a.text-link
        {:href "#"
         :on-click
         #(grid/open-modal app-atom :web.demo/register-start
            {:config
             {:size :small
              :blur-bg? true}})}
        "Open register start modal"]]
      [:ul
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-email
             {:config
              {:size :small
               :blur-bg? true}})}
         "Open email register modal"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-created
             {:config
              {:size :small
               :success? true
               :blur-bg? true}})}
         "Open register confirmed modal"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-exists
             {:config
              {:size :small
               :error? true
               :blur-bg? true}})}
         "Open register exists modal (has password)"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-verifyprecreated
             {:config
              {:size :small
               :warning? true
               :blur-bg? true}})}
         "Open register exists modal (pre-created account)"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-verifyemail
             {:config
              {:size :small
               :blur-bg? true}})}
         "Open verify email modal (pre-created account)"]]
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/register-verificationsent
             {:config
              {:size :small
               :success? true
               :blur-bg? true}})}
         "Open verify email sent modal"]]]]
     [:li
      [:b
       [:a.text-link
        {:href "#"
         :on-click
         #(grid/open-modal app-atom :web.demo/forgotpassword
            {:config
             {:size :small
              :blur-bg? true}})}
        "Open forgot password start modal"]]
      [:ul
       [:li
        [:a.text-link
         {:href "#"
          :on-click
          #(grid/open-modal app-atom :web.demo/forgotpasswordsent
             {:config
              {:size :small
               :success? true
               :blur-bg? true}})}
         "Open password reset link sent modal"]]]]]]])


(defmethod flow/render-screen :web.demo [app-atom _]
  (demo-list-page app-atom))

